import { showToast } from "@/utils/toastUtils";
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
      onError: (error: any) => {
        const displayMessage = error?.response?.data?.display_message;
        if (displayMessage) {
          showToast({
            message: displayMessage,
            type: "error",
          });
        }
      },
    },
  },
});
